import React from 'react';
import QuestionCard from '../forms/QuestionCard';
import { useFormContext } from '../../context/FormContext';

const IndustryQuestions = ({ 
  questionNumber, 
  categories, 
  totalQuestions 
}) => {
  const { formData, handleInputChange } = useFormContext();
  
  switch(questionNumber) {
    case 1:
      return (
        <QuestionCard 
          categoryIcon={categories[2].icon}
          categoryName={categories[2].name}
          questionNumber={1}
          totalQuestions={totalQuestions}
          title="下面这些领域中，哪几个你觉得有点有趣、想要探索了解更多？" 
          subtitle="(可多选；凭直觉选，没有对错，帮助我们了解你对哪些方向比较有感觉～)"
          inputType="checkbox"
          options={[
            "金融",
            "软件开发 / 编程",
            "科技产品 / 用户体验 / 产品设计",
            "咨询 / 商业策略",
            "人工智能 / 机器学习（比如训练模型、算法开发、做AI工程）",
            "医疗 / 生命科学 / 健康行业",
            "数据分析 / 商业分析",
            "教育 / 教师",
            "市场营销 / 品牌 / 广告",
            "数学 / 建模 / 量化方向",
            "非营利 / 公共政策",
            "媒体 / 娱乐 / 文化",
            "创业 / 初创公司",
            "科研 / 学术研究",
            "工程类（电子、机械、硬件、制造）",
            "人力资源 / 人才管理",
            "房地产 / 商业地产",
          ]}
          value={formData.industryInterests}
          onChange={(values) => handleInputChange('industryInterests', values)}
          customOption={true}
          customValue={formData.industryInterestsOther}
          onCustomChange={(value) => handleInputChange('industryInterestsOther', value)}
        />
      );
    case 2:
      return (
        <QuestionCard 
          categoryIcon={categories[2].icon}
          categoryName={categories[2].name}
          questionNumber={2}
          totalQuestions={totalQuestions}
          title="你为什么选择了上面那些觉得有趣/想了解的领域？" 
          subtitle="对于每一个选择的领域，请描述下大概的原因（比如：家里有人做这个、以前做过类似的活动/项目觉得有趣、上过喜欢的课、朋友都选这个）"
          value={formData.industryInterestsReason}
          onChange={(value) => handleInputChange('industryInterestsReason', value)}
          inputType="textarea"
        />
      );
    case 3:
      return (
        <QuestionCard 
          categoryIcon={categories[2].icon}
          categoryName={categories[2].name}
          questionNumber={3}
          totalQuestions={totalQuestions}
          title="有没有哪些领域你&quot;肯定不想做&quot;或&quot;完全不感兴趣&quot;？" 
          value={formData.notInterestedIndustries}
          onChange={(value) => handleInputChange('notInterestedIndustries', value)}
          inputType="textarea"
        />
      );
    case 4:
      return (
        <QuestionCard 
          categoryIcon={categories[2].icon}
          categoryName={categories[2].name}
          questionNumber={4}
          totalQuestions={totalQuestions}
          title="你觉得自己对未来想做的领域有多确定？" 
          subtitle="(例如：已经很清楚，想做XXX；或者是有几个方向，但还没确定，想从XXX和XXX中挑一个；或者是完全不确定，我想根据XXX因素来决定，或者其他的回答)"
          value={formData.careerCertainty}
          onChange={(value) => handleInputChange('careerCertainty', value)}
          inputType="textarea"
        />
      );
    default:
      return null;
  }
};

export default IndustryQuestions;